module.exports = __webpack_public_path__ + "img/auth.e917bd6d.jpg";